import React, { useMemo } from "react"
import { useDocuments, useDocument } from "@/lib/queries"
import { useAuth } from "@/contexts/AuthContext"
import { WorkflowsListView } from "@/components/shared/WorkflowsListView"

const customerPdfUrl = (workflowSlug: string, crSlug: string, activityId?: number) =>
  `/api/v1/customer/documents/${workflowSlug}/pdf?clinical_review=${encodeURIComponent(crSlug)}${activityId ? `&activity=${activityId}` : ""}`

export function WorkflowsListPage() {
  const { user } = useAuth()
  const { data: groups, isLoading } = useDocuments()

  const docs = useMemo(
    () =>
      groups?.find((g) => g.document_type === "workflow_template")?.documents ??
      [],
    [groups]
  )

  return (
    <WorkflowsListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useDocument}
      pdfUrl={user?.role === "manager" && !user.preview_mode ? customerPdfUrl : undefined}
    />
  )
}
